import { render, staticRenderFns } from "./ApplicantsGrid.vue?vue&type=template&id=12fc41fb"
import script from "./ApplicantsGrid.vue?vue&type=script&lang=js"
export * from "./ApplicantsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports